import types, {baseAsyncTypes} from '../../actions/types'
import Immutable from 'seamless-immutable'
import finalise from './finalise'
import user from './user'
import {combineReducers} from 'redux'
import {createDataBlockReducer} from 'helpers/reducer'

const forgotPassword = createDataBlockReducer(baseAsyncTypes.FORGOT_PASSWORD)()

export const username = (state = null, action) => {
  switch (action.type) {
    case types.UPDATE_LOGIN_USERNAME:
      return action.username
    default:
      return state
  }
}

export const password = (state = null, action) => {
  switch (action.type) {
    case types.UPDATE_LOGIN_PASSWORD:
      return action.password
    case types.LOGOUT_ATTEMPT:
      return null
    default:
      return state
  }
}

export const sessionChecked = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.SESSION_LOGIN_SUCCESS:
    case types.SESSION_LOGIN_FAILURE:
      return Immutable(true)
    default:
      return state
  }
}

export const attemptingLogin = (state = false, action) => {
  switch (action.type) {
    case types.LOGIN_ATTEMPT:
    case types.AUTHENTICATE_TOTP_LOGIN_ATTEMPT:
      return true
    case types.LOGIN_SUCCESS:
    case types.LOGIN_FAILURE:
    case types.AUTHENTICATE_TOTP_LOGIN_SUCCESS:
    case types.AUTHENTICATE_TOTP_LOGIN_FAILURE:
    case types.SHOW_TFA_LOGIN_FORM:
      return false
    default:
      return state
  }
}

export const loginError = (state = null, action) => {
  switch (action.type) {
    case types.LOGIN_ATTEMPT:
    case types.LOGIN_SUCCESS:
    case types.UPDATE_LOGIN_USERNAME:
    case types.UPDATE_LOGIN_PASSWORD:
      return null
    case types.LOGIN_FAILURE:
      return action.error
    case types.LOGOUT_SUCCESS:
      return action.message
    default:
      return state
  }
}

export const loginErrorCode = (state = null, action) => {
  switch (action.type) {
    case types.LOGIN_ATTEMPT:
    case types.LOGIN_SUCCESS:
    case types.UPDATE_LOGIN_USERNAME:
    case types.UPDATE_LOGIN_PASSWORD:
      return null
    case types.LOGIN_FAILURE:
      return action.code
    default:
      return state
  }
}

export const attemptingRefreshAuth = (state = false, action) => {
  switch (action.type) {
    case types.REFRESH_AUTH_ATTEMPT:
    case types.REFRESH_AUTH_TOTP_ATTEMPT:
      return true
    case types.REFRESH_AUTH_SUCCESS:
    case types.REFRESH_AUTH_FAILURE:
    case types.REFRESH_AUTH_TOTP_REQUIRED:
    case types.REFRESH_AUTH_TOTP_SUCCESS:
    case types.REFRESH_AUTH_TOTP_FAILURE:
      return false
    default:
      return state
  }
}

export const refreshAuthError = (state = null, action) => {
  switch (action.type) {
    case types.REFRESH_AUTH_ATTEMPT:
    case types.REFRESH_AUTH_SUCCESS:
    case types.REFRESH_AUTH_TOTP_ATTEMPT:
    case types.REFRESH_AUTH_TOTP_SUCCESS:
      return null
    case types.REFRESH_AUTH_FAILURE:
    case types.REFRESH_AUTH_TOTP_FAILURE:
      return action.error

    default:
      return state
  }
}

export const refreshAuthToken = (state = null, action) => {
  switch (action.type) {
    case types.REFRESH_AUTH_TOTP_REQUIRED:
      return action.token
    case types.REFRESH_AUTH_ATTEMPT:
    case types.REFRESH_AUTH_SUCCESS:
    case types.REFRESH_AUTH_TOTP_SUCCESS:
      return null
    default:
      return state
  }
}

export const attemptingResetPassword = (state = null, action) => {
  switch (action.type) {
    case types.RESET_PASSWORD_ATTEMPT:
      return true
    case types.RESET_PASSWORD_SUCCESS:
      return false
    case types.RESET_PASSWORD_FAILURE:
      return false
    default:
      return state
  }
}

export const resetPasswordError = (state = null, action) => {
  switch (action.type) {
    case types.RESET_PASSWORD_ATTEMPT:
      return null
    case types.RESET_PASSWORD_SUCCESS:
      return null
    case types.RESET_PASSWORD_FAILURE:
      return action.error
    default:
      return state
  }
}

export const resetPasswordIsSuccessful = (state = false, action) => {
  switch (action.type) {
    case types.RESET_PASSWORD_ATTEMPT:
      return false
    case types.RESET_PASSWORD_SUCCESS:
      return true
    case types.RESET_PASSWORD_FAILURE:
      return false
    default:
      return state
  }
}

export const attemptingActivateUser = (state = null, action) => {
  switch (action.type) {
    case types.ACTIVATE_USER_ATTEMPT:
      return true
    case types.ACTIVATE_USER_SUCCESS:
      return false
    case types.ACTIVATE_USER_FAILURE:
      return false
    case types.ACTIVATE_USER_JWT_ATTEMPT: return true
    case types.ACTIVATE_USER_JWT_SUCCESS: return false
    case types.ACTIVATE_USER_JWT_FAILURE: return false
    default:
      return state
  }
}

export const activateUserError = (state = null, action) => {
  switch (action.type) {
    case types.ACTIVATE_USER_ATTEMPT:
    case types.ACTIVATE_USER_SUCCESS:
     case types.ACTIVATE_USER_JWT_ATTEMPT:
    case types.ACTIVATE_USER_JWT_SUCCESS: return null
    case types.ACTIVATE_USER_FAILURE:
     case types.ACTIVATE_USER_JWT_FAILURE: return action.error
    default:
      return state
  }
}

export const attemptingSignUp = (state = null, action) => {
  switch (action.type) {
    case types.SIGN_UP_ATTEMPT:
      return true
    case types.SIGN_UP_SUCCESS:
      return false
    case types.SIGN_UP_FAILURE:
      return false
    default:
      return state
  }
}

export const signUpError = (state = null, action) => {
  switch (action.type) {
    case types.SIGN_UP_ATTEMPT:
      return null
    case types.SIGN_UP_SUCCESS:
      return null
    case types.SIGN_UP_FAILURE:
      return action.error
    default:
      return state
  }
}

export const signatureUpdated = (state = Immutable(new Date().getTime()), action) => {
  switch (action.type) {
    case types.SETTINGS_UPLOAD_SIGNATURE_SUCCESS:
    case types.SETTINGS_DELETE_SIGNATURE_SUCCESS:
      return Immutable(new Date().getTime())
    default:
      return state
  }
}

export const logoUpdated = (state = Immutable(new Date().getTime()), action) => {
  switch (action.type) {
    case types.SETTINGS_UPLOAD_LOGO_SUCCESS:
    case types.SETTINGS_DELETE_LOGO_SUCCESS:
      return Immutable(new Date().getTime())
    default:
      return state
  }
}

// Note: this is duplicated with user.featureToggles when the user is loaded,
//       but also holds the global feature toggles when the user is not loaded.
export const featureToggles = (state = [], action) => {
  switch (action.type) {
    case types.SET_FEATURE_TOGGLES:
      return action.featureToggles
    default:
      return state
  }
}

export const pricingCalculatorAccessToken = (state = null, action) => {
  switch (action.type) {
    case types.PRICING_CALCULATOR_ACCESS_TOKEN_CREATE_SUCCESS:
      return action.token
    case types.LOGOUT_ATTEMPT:
      return null
    default:
      return state
  }
}

export default combineReducers({
  forgotPassword,
  username,
  password,
  user,
  attemptingLogin,
  sessionChecked,
  loginError,
  loginErrorCode,
  signatureUpdated,
  logoUpdated,
  finalise,
  featureToggles,
  attemptingRefreshAuth,
  refreshAuthError,
  refreshAuthToken,
  attemptingResetPassword,
  resetPasswordError,
  resetPasswordIsSuccessful,
  attemptingActivateUser,
  activateUserError,
  attemptingSignUp,
  signUpError,
  pricingCalculatorAccessToken,
})
